var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-switch"},[_c('div',{class:['e__switch',{'e_is-checked':_vm.value}]},[_c('span',{staticClass:"e__switch-core",on:{"click":_vm.toggle}})]),_c('div',{staticClass:"text",on:{"click":_vm.toggle}},[_vm._v("切换"+_vm._s(_vm.value ?'卡片':'地图')+"显示")])])
}
var staticRenderFns = []

export { render, staticRenderFns }